module.exports = __webpack_public_path__ + "img/2.5153ed5e.jpg";